/**
 * npcs.ts — Typed NPC data with lookup by ID.
 */

import type { NPC } from './types';
import npcData from './npcs.json';

/** All 12 NPCs as a typed array. */
export const npcs: NPC[] = npcData as NPC[];

/** Lookup NPC by ID. Built once on first import. */
const npcMap = new Map<string, NPC>(npcs.map((npc) => [npc.id, npc]));

/** Get an NPC by ID, or undefined if not found. */
export function getNPC(id: string): NPC | undefined {
  return npcMap.get(id);
}

/** Get all NPC IDs. */
export function getNPCIds(): string[] {
  return npcs.map((npc) => npc.id);
}
